package com.swetdot.swetgram.ui.design

import androidx.compose.runtime.Composable
import androidx.compose.ui.window.DialogProperties

internal actual fun swetSheetDialogProperties(
    dismissOnBackPress: Boolean,
    dismissOnClickOutside: Boolean,
    usePlatformDefaultWidth: Boolean,
): DialogProperties = DialogProperties(
    dismissOnBackPress = dismissOnBackPress,
    dismissOnClickOutside = dismissOnClickOutside,
    usePlatformDefaultWidth = usePlatformDefaultWidth,
)

@Composable
internal actual fun platformReduceMotion(): Boolean =
    js("typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches") as Boolean
